// The version shown in the nav rail. It comes from the workspace package.json, which
// the publish workflow stamps (`tag_root_package_json` in dev.publish-packages.yml), so
// a deployed build reports its real version while local builds read 0.0.0.
//
// Imported as a named export on purpose: the bundler can then drop the rest of the
// manifest instead of bundling the whole dependency list.
import { version } from '../../../../../package.json';

export const APP_VERSION: string = version;
